<div class="container" style="padding-top: 30px;">
    <h4 style="font-size: 20px;font-family:Ubuntu-Medium !important ;">{{VerifyStatus}}</h4>
    </div>
